var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
var DoctorClinicAppointmentsReport = /** @class */ (function (_super) {
    __extends(DoctorClinicAppointmentsReport, _super);
    function DoctorClinicAppointmentsReport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DoctorClinicAppointmentsReport.prototype.getClinicName = function () {
        return this.clinic_name;
    };
    DoctorClinicAppointmentsReport.prototype.getClinicId = function () {
        return Number(this.clinic_id);
    };
    DoctorClinicAppointmentsReport.prototype.getTotalAppointment = function () {
        return Number(this.total_appointments);
    };
    return DoctorClinicAppointmentsReport;
}(Model));
export default DoctorClinicAppointmentsReport;
